export const validateNumericInput = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];

  if (allowedKeys.includes(event.key)) return;

  if (!/^[0-9]$/.test(event.key)) {
    event.preventDefault();
    return;
  }

  const input = event.currentTarget;
  const { value, selectionStart } = input;

  if (event.key === "0" && (!value || (selectionStart === 0 && value === ""))) {
    event.preventDefault();
  }
};

export const validateDecimalInput = (
  event: React.KeyboardEvent<HTMLInputElement>
): void => {
  const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];
  const decimalSeparators = [",", "."];

  if (allowedKeys.includes(event.key)) return;

  const input = event.currentTarget;
  const { value, selectionStart } = input;

  if (decimalSeparators.includes(event.key)) {
    if (value.includes(",") || value.includes(".")) {
      event.preventDefault();
    } else if (selectionStart === 0) {
      event.preventDefault();
    }
    return;
  }

  validateNumericInput(event);
};
